import { Injectable } from '@angular/core';
import { TaskQueueInterface, TaskQueueStorageServiceInterface } from './interfaces';

@Injectable({ providedIn: 'root' })
export class TaskQueueStorageService implements TaskQueueStorageServiceInterface {
  private readonly TaskQueueStorageKey = 'crm:task-queue';

  async load(): Promise<TaskQueueInterface | null> {
    try {
      const storage = localStorage.getItem(this.TaskQueueStorageKey);
      return storage ? JSON.parse(storage) : null;
    } catch (error) {
      return null;
    }
  }

  async save(taskQueue: TaskQueueInterface): Promise<void> {
    localStorage.setItem(this.TaskQueueStorageKey, JSON.stringify(taskQueue));
  }

  async empty(): Promise<void> {
    localStorage.removeItem(this.TaskQueueStorageKey);
  }
}
